/*
 this component is used for UnusedRoomClosed and PlayerAExitRoom statuses
 discuss, maybe it should be in finish-view
*/
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { CardPlayerEnum, FinishStateEnum } from 'modules/Room/constants/enums';
import { useGameStatusStore } from 'modules/Room/game-status/store/game-status-store';

import { InfoBannerType } from 'shared/components/ui/InfoBanner/InfoBanner';
import { MoveStatusRenderer } from 'shared/components/ui/MoveStatusRenderer/MoveStatusRenderer';
import PrimaryButton from 'shared/components/ui/PrimaryButton/PrimaryButton';
import { ROUTES } from 'shared/constants';
import { RoomStatusEnum, WinnerStatusEnum } from 'shared/constants/shared-enums';
import useMediaQuery from 'shared/hooks/useMediaQuery';
import { useRoomStore } from 'shared/store/roomStore';

import { stateMapping } from './stetMapping';

interface IGameFinishViewsProps {
  player?: CardPlayerEnum;
}

const GameFinishViews = ({ player }: IGameFinishViewsProps) => {
  const { activeRoomId } = useParams();
  const { roomStatus, winnerStatus, amIPlayerA } = useRoomStore();
  const { t } = useTranslation();
  const [viewState, setViewState] = useState<FinishStateEnum | null>(null);
  const navigate = useNavigate();
  const { resetGameStatus } = useGameStatusStore();
  useEffect(() => {
    if (roomStatus === RoomStatusEnum.Closed) {
      resetGameStatus();
    }
  }, [roomStatus]);
  const isMobile = useMediaQuery('(max-width: 1199px)');
  useEffect(() => {
    if (winnerStatus && roomStatus === RoomStatusEnum.Closed && activeRoomId) {
      switch (winnerStatus) {
        case WinnerStatusEnum.PlayerAExitRoom:
          setViewState(FinishStateEnum.YouExitRoom);
          break;
        case WinnerStatusEnum.UnusedRoomClosed:
          setViewState(FinishStateEnum.NoOneWin);
          break;
        default:
          setViewState(null);
      }
    }
  }, [winnerStatus, roomStatus, activeRoomId, amIPlayerA]);

  const startNewGameHandler = () => {
    useRoomStore.getState()?.resetStore();
    navigate(ROUTES.LOBBY);
  };

  const textGenerator = () => {
    if (!viewState) return null;

    const content = stateMapping[viewState];
    return (
      <MoveStatusRenderer
        title={
          <div>
            {viewState === FinishStateEnum.YouWin ? (
              <p className="my-3 text-[14px] font-bold sm:text-[24px]">
                {t('gameFinishViews.youWin')}
              </p>
            ) : null}

            {viewState === FinishStateEnum.YouLost ? (
              <p className="my-3 text-[14px] font-bold sm:text-[24px]">
                {t('gameFinishViews.youLose')}
              </p>
            ) : null}

            {content.texts.map((text, index) => (
              <p
                key={text}
                className={`text-center text-md text-white sm:text-[17px] ${
                  index !== content.texts.length - 1 ? 'my-3' : ''
                }`}
              >
                {t(text)}
              </p>
            ))}
          </div>
        }
        type={viewState === FinishStateEnum.YouWin ? InfoBannerType.INFO : InfoBannerType.WARNING}
      />
    );
  };

  if (!viewState || player === CardPlayerEnum.Opponent || player === CardPlayerEnum.Connect)
    return null;

  return (
    <div className="flex w-full flex-col gap-4">
      {textGenerator()}
      <div className={`flex justify-center ${isMobile ? 'hidden' : ''}`}>
        <PrimaryButton text={t('common.selectNewBet')} onClick={startNewGameHandler} />
      </div>
    </div>
  );
};

export default GameFinishViews;
